import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Member } from "@/model";
import memberRepository from "@/repository/memberRepository";
import { permissionQueryKeys } from "@/query/permission";
import { memberQueryKeys } from "./keys";


export const useDeleteMember = (scenarioId: string) => {
    const queryClient = useQueryClient();

    return useMutation<Member, AxiosError, string>({
        mutationKey: ['member', 'delete'],
        mutationFn: async (memberId: string) => {
            const { data } = await memberRepository.delete(scenarioId, memberId);
            return data.result;
        },
        retry: false,
        onSuccess: async () => {
            await Promise.all([
                queryClient.refetchQueries({ queryKey: permissionQueryKeys.me(scenarioId) }),
                queryClient.invalidateQueries({ queryKey: memberQueryKeys.all(scenarioId) })
            ]);
        }
    });
};
